// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","884":"admin"}[chunkId] || chunkId) + "." + {"282":"237c0fc2","332":"50a324b3","354":"a47703d7","418":"0f0ede73","594":"a2520a30","884":"eefef415"}[chunkId] + ".js";
};